// extracted by mini-css-extract-plugin
export default {"inputCustomWrapper":"styles_inputCustomWrapper__fXXZF","inputError":"styles_inputError__RgS4F"};